// frontend/src/utils/agoWords.ts
//
// "When was this device last used" in words.
//
// 🔒 THIS IS HOW A PERSON SPOTS A DEVICE THAT IS NOT THEIRS. A label alone
// ("Redmi Note 12") says nothing — half the office carries one. "last used 4
// minutes ago" while the handset is in your pocket is the whole signal, and it
// is the reason spec D7 gives reps a screen of their own at all.
//
// Two lengths, one clock: the long form for a screen a person reads once and
// must understand immediately (the block screen, their own devices), the short
// form for an admin scanning a column of rows.
//
// 🔒 PLATFORM ONLY (P1/P3). No product vocabulary, no product import — copied to
// Sun Stellar unchanged.

function minutesSince(iso: string): number {
  return Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
}

/** "just now" · "4 minutes ago" · "2 hours ago" · "3 days ago" */
export function agoWords(iso: string): string {
  const mins = minutesSince(iso);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins} minute${mins === 1 ? '' : 's'} ago`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `${hrs} hour${hrs === 1 ? '' : 's'} ago`;
  const days = Math.round(hrs / 24);
  return `${days} day${days === 1 ? '' : 's'} ago`;
}

/** "4m ago" · "2h ago" · "3d ago". Empty string for a missing timestamp, so a
 *  caller can drop it out of a `·`-joined line with `.filter(Boolean)`. */
export function agoShort(iso: string | null): string {
  if (!iso) return '';
  const m = minutesSince(iso);
  if (m < 60) return `${m}m ago`;
  if (m < 1440) return `${Math.round(m / 60)}h ago`;
  return `${Math.round(m / 1440)}d ago`;
}
